import {
    CREATE_APPOINTMENT_STARTED,
    CREATE_APPOINTMENT_SUCCESS,
    CREATE_APPOINTMENT_FAILURE,
    GET_APPOINTMENTS_STARTED,
    GET_APPOINTMENTS_SUCCESS,
    GET_APPOINTMENTS_FAILURE,
    GET_APPOINTMENT_DETAIL_STARTED,
    GET_APPOINTMENT_DETAIL_SUCCESS,
    GET_APPOINTMENT_DETAIL_FAILURE,
    CREATE_BLOCK_TIME_STARTED,
    CREATE_BLOCK_TIME_SUCCESS,
    CREATE_BLOCK_TIME_FAILURE,
    UPDATE_BLOCK_TIME_STARTED,
    UPDATE_BLOCK_TIME_SUCCESS,
    UPDATE_BLOCK_TIME_FAILURE,
    REMOVE_BLOCK_TIME_STARTED,
    REMOVE_BLOCK_TIME_SUCCESS,
    REMOVE_BLOCK_TIME_FAILURE,
    UPDATE_APPOINTMENT_STARTED,
    UPDATE_APPOINTMENT_SUCCESS,
    UPDATE_APPOINTMENT_FAILURE,
    REMOVE_ERROR_MESSAGE
} from "../../constants/appointment/appointment";

const initialState = {
    appointments: [],
    appointmentDetail: null,
    staff: null,
    staffHour: null,
    holidays: [],
    specialHours: [],
    loading: false,
    error: null,
    message: null,
};

export default function appointment(state = initialState, action) {
    switch (action.type) {
        case UPDATE_APPOINTMENT_STARTED:
            return {
                ...state,
                loading: true,
                error: null,
                message: null,
            };
        case UPDATE_APPOINTMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                appointmentDetail: action.payload.data,
                message: "Appointment updated successfully!",
            };
        case UPDATE_APPOINTMENT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };

        case CREATE_APPOINTMENT_STARTED:
            return {
                ...state,
                loading: true,
                error: null,
                message: null,
            };
        case CREATE_APPOINTMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                appointmentDetail: action.payload.data,
                message: "Appointment created successfully!",
            };
        case CREATE_APPOINTMENT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };
        case GET_APPOINTMENT_DETAIL_STARTED:
            return {
                ...state,
                loading: true,
                error: null,
                message: null,
            };

        case GET_APPOINTMENT_DETAIL_SUCCESS:
            return {
                ...state,
                appointmentDetail: action.payload.appointmentDetail,
                error: null,
                loading: false,
            };

        case GET_APPOINTMENT_DETAIL_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };

        case GET_APPOINTMENTS_STARTED:
            return {
                ...state,
                loading: true,
                error: null,
                message: null,
            };

        case GET_APPOINTMENTS_SUCCESS:
            return {
                ...state,
                appointments: action.payload.appointments,
                staff: action.payload.staff,
                staffHour: action.payload.staffHour,
                holidays: action.payload.holidayAndSpecialHour.filter((item) => item.isSpecialHour === false),
                specialHours: action.payload.holidayAndSpecialHour.filter((item) => item.isSpecialHour === true),
                error: null,
                loading: false,
            };

        case GET_APPOINTMENTS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };

        case CREATE_BLOCK_TIME_STARTED:
            return {
                ...state,
                loading: true,
                error: null,
                message: null,
            };
        case CREATE_BLOCK_TIME_SUCCESS:
            return {
                ...state,
                loading: false,
                message: "Block time created successfully!"
            };
        case CREATE_BLOCK_TIME_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error
            };

        case UPDATE_BLOCK_TIME_STARTED:
            return {
                ...state,
                loading: true,
                error: null,
                message: null,
            };
        case UPDATE_BLOCK_TIME_SUCCESS:
            return {
                ...state,
                loading: false,
                message: "Block time has been changed successfully!"
            };
        case UPDATE_BLOCK_TIME_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error
            };

        case REMOVE_BLOCK_TIME_STARTED:
            return {
                ...state,
                loading: true,
                error: null,
                message: null,
            };
        case REMOVE_BLOCK_TIME_SUCCESS:
            return {
                ...state,
                loading: false,
                message: "Block time has been removed successfully!"
            };
        case REMOVE_BLOCK_TIME_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error
            };

        case REMOVE_ERROR_MESSAGE:
            return {
                ...state,
                loading: false,
                error: null,
                message: null,
            };
        default:
            return { ...state };
    }
}
